const startFormatterSameYear = new Intl.DateTimeFormat(undefined, {
  month: 'long',
  day: 'numeric',
});

const startFormatterWithYear = new Intl.DateTimeFormat(undefined, {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

const endFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

export function formatDigestWindow(start: Date, end: Date) {
  const sameYear = start.getFullYear() === end.getFullYear();
  const startFormatter = sameYear
    ? startFormatterSameYear
    : startFormatterWithYear;

  return `${startFormatter.format(start)} to ${endFormatter.format(end)}`;
}

export function truncateMiddle(value: string) {
  if (value.length <= 14) {
    return value;
  }

  return `${value.slice(0, 6)}...${value.slice(-4)}`;
}

/** Display name for a review author (domain > wallet > anonymous). */
export function getReviewerLabel(review: {
  isReviewerAccountDeleted: boolean;
  domain: string | null;
  walletAddress: string | null;
}) {
  if (review.isReviewerAccountDeleted) {
    return 'Deleted reviewer';
  }

  if (review.domain) {
    return review.domain;
  }

  if (review.walletAddress) {
    return truncateMiddle(review.walletAddress);
  }

  return 'Anonymous reviewer';
}
